RCDPW.module('RCDPW.validator.rules.administration.AppForm', {
    appName: {
        required: true,
        rangelength: [1, 64],
        noWhiteSpace: true
    },
    desc: {
        rangelength: [0, 256]
    },
    appPlatform: 'required',
    scope: 'required'
});
